import './tracklist.module.css';
import Track from './Track';

function Tracklist(props) {
    return (
        <div className="Tracklist">
            {props.tracks.map((track) => (
        // Generate a Track component for each track in the tracks prop.
        <Track key={track.uri} track={track} isRemove={props.isRemove} onAdd={props.onAdd} onRemove={props.onRemove} />
         ))}
        </div>
    )
}

export default Tracklist;
